import React, { Component } from 'react';
import TopPicksOfTheMonth from './TopPicksOfTheMonth';
import Deals from './Deals';
import MosaicAndLongBanner from './MosaicAndLongBanner';
import CustomContentAndTestimonials from './CustomContentAndTestimonials';
import WhatYouCanCreate from './WhatYouCanCreate';
import HomepageSEO from './Seo';
import { withTranslation } from '../Common/Translations';
import Banner from '../Banner';
import HomeBanner from '../Carousel/HomeBanner';
import { compose, withProps } from 'recompose';
import { isMobile, isMobileDevice } from 'react-device-detect';
import { withHomepageData } from '../Common/Providers/HomepageApi';

export const buildSectionAndProps = (component, props) => component.map((list, index) => {
  const componentName = list.pageComponent;
  const banner = new HomeBanner();
  switch (componentName) {
    case 'HomeBanner':
      return <Banner key={componentName} target={banner} />;
    case 'WhatYouCanCreate':
      return <WhatYouCanCreate key={componentName} {...props}/>;
    case 'TopPicksOfTheMonth':
      return <TopPicksOfTheMonth key={componentName} {...props}/>;
    case 'MosaicAndLongBanner':
      return <MosaicAndLongBanner key={componentName} {...props}/>;
    case 'Deals':
      return <Deals key={componentName} {...props}/>;
    case 'CustomContentAndTestimonials':
      return <CustomContentAndTestimonials key={componentName} {...props}/>;
    case 'HomepageSEO':
      return <HomepageSEO key={componentName}/>;
    default:
      return null;
  }
});

export const emptyPayload = (props) => {
  const banner = new HomeBanner();
  return (
    // remember to add swicth case accordingly in above buildSectionAndProps()
    // when u introduce a new component into homepage below
    <div>
      <Banner target={banner} />
      <WhatYouCanCreate {...props}/>
      <TopPicksOfTheMonth {...props}/>
      <MosaicAndLongBanner {...props}/>
      <Deals {...props}/>
      <CustomContentAndTestimonials {...props}/>
      <HomepageSEO />
    </div>
  );
}

class Container extends Component {
  render() {
    if (!this.props.homepageContent.pageContainers ||
        this.props.homepageContent.pageContainers.length == 0) {
      return (<div className="landing-page">{emptyPayload(this.props)}</div>);
    }
    return (
      <div className="landing-page">
          <div>
            {buildSectionAndProps(this.props.homepageContent.pageContainers, this.props)}
          </div>
      </div>
    );
  }
}

const enhance = compose(
  withTranslation('landing_page'),
  withProps(() => ({
    isMobile: isMobileDevice
  })),
  withHomepageData((isMobile) ? 'mobile-web' : 'desktop'),
);

export default enhance(Container);
export const undecorated = Container;



// WEBPACK FOOTER //
// ./src/LandingPage/Container.js